<template>
  <footer class="footer ">
    <div class="container">
      <div class="footer-links row between-xs">
        <div class="col-xs-6 col-sm-4 col-lg"><a href="/">About</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="#services">Services</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="#works">Work</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="/">Products</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="/">Thoughts</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="/">Careers</a></div>
        <div class="col-xs-6 col-sm-4 col-lg"><a href="#contact">Contact</a></div>
      </div>
      <div class="blocklinks">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-lg-3">
                <div class="box">
                  <a href="/">Design Thinking Workshop</a>
                  <a href="/">Rapid Prototyping</a>
                  <a href="/">High Fidelity Wireframing</a>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-lg-3">
                <div class="box">
                  <a href="/">Heuristic Evaluation</a>
                  <a href="/">Discovery Workshop</a>
                  <a href="/">Icon Design</a>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-lg-3">
                <div class="box">
                  <a href="/">Front End Development</a>
                  <a href="/">User Interface Design</a>
                  <a href="/">User & Usability Research</a>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-lg-3">
                <div class="box query">
                  <p> Need an NDA before telling us all about the project?</p>
                  <a href="mailto:interact@huehexdesign.com">interact@huehexdesign.com</a>
                </div>
            </div>
          </div>
      </div>
      <div class="copyright center-xs"> © 2019  <img src="@/assets/heart.svg" alt=""> Huehex Design LLP</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'huFooter',
  props: {
    title: String
  }
}
</script>

<style scoped lang="scss">
.footer{
  background-color: #2f2b39;
  overflow: hidden;
  .container{
    margin-top:70px;
    margin-bottom:100px;
  }
  .blocklinks{
    margin:70px 0;
  }
  .footer-links,.blocklinks{
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.15;
    letter-spacing: normal;
    
    a{
      color: $white;
    //   flex: 0 0 auto;
    //   flex-basis: 10%;
    // max-width: 10%;
      text-decoration: none;
    }
  }
  .query{
      p {line-height: 1.15; }
      a{
        font-size: 16px;
        font-weight: normal;
        border-bottom:1px solid $yellow;
      }
    }
}
</style>
